import state from './state'
import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

import chatsState from './chats'

const modules = {
  dashboard: {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,

    modules: {
      chats: chatsState,
    }
  }
}

export default modules
